import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faQuoteRight } from '@fortawesome/free-solid-svg-icons';

const TestimonialSection = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      content: "After migrating our strategies to ASSI, execution latency decreased significantly and our algorithmies achieved better PAL.",
      author: "Algo Fung Manager",
      role: "Quant Trading, Mumbai",
      image: "assets/images/icon/avatar.webp"
    },
    {
      id: 2,
      content: "Their portfoutrteem redeseigned our allocation and has helped us better understand our family's wealth drivers fects.",
      author: "HNWI Clients",
      role: "Family Office, Delhi",
      image: "assets/images/icon/avatar.webp"
    },
    {
      id: 3,
      content: "After migrating our strategies to ASSI, execution latency decreased significantly and our algorithmies achieved better PAL.",
      author: "Algo Fung Manager",
      role: "Quant Trading, Mumbai",
      image: "assets/images/icon/avatar.webp"
    }
  ];

  return (
    <section className="testimonial padding-top padding-bottom-style2 bg-color py-5">
      <div className="container">
        <div className="section-header d-md-flex align-items-center justify-content-between">
          <div className="section-header__content">
            <h2 className="mb-10"> <span></span></h2>
            <div class="section-header text-center mb-0"><h2>What Our <span class="style2">Clients Says</span></h2></div>
          </div>
          <div className="section-header__action">
            <div className="swiper-nav">
              <button ref={prevRef} className="swiper-nav__btn testimonial__slider-prev">
                <FontAwesomeIcon icon={faAngleLeft} />
              </button>
              <button ref={nextRef} className="swiper-nav__btn testimonial__slider-next active">
                <FontAwesomeIcon icon={faAngleRight} />
              </button>
            </div>
          </div>
        </div>

        <div className="testimonial__wrapper" data-aos="fade-up" data-aos-duration="1000">
          <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
              swiper.navigation.init();
              swiper.navigation.update();
            }}
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
              768: {
                slidesPerView: 1,
              },
              992: {
                slidesPerView: 2,
              }
            }}
            className="testimonial__slider"
          >
            {testimonials.map((testimonial) => (

              <SwiperSlide key={testimonial.id} className="new-shadow">
                <div className="testimonial__item testimonial__item--style1">
                  <div className="testimonial__item-inner">
                    <div className="testimonial__item-content">
                      <p className="mb-0">{testimonial.content}</p>
                      <div className="testimonial__footer">
                        <div className="testimonial__author">
                          <div className="testimonial__author-thumb">
                            <img src={testimonial.image} alt="author" />
                          </div>
                          <div className="testimonial__author-designation">
                            <h6>{testimonial.author}</h6>
                            <span>{testimonial.role}</span>
                          </div>
                        </div>
                        <div className="testimonial__quote">
                          <span><FontAwesomeIcon icon={faQuoteRight} /></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;